export default __webpack_public_path__ + "static/media/why_allina_02.74a2fd62.png";